module.exports = __webpack_public_path__ + "media/newstyle/images/pocket-40bff81b4c965d4a046974a70a674eac.svg";